export default "__VITE_ASSET__Cjj$XJv3__"